export default "__VITE_ASSET__BQ$Y959E__"